import {
  IContextBuilder,
  ITreatmentStepScopeData,
  ITreatmentStepTemplateContext,
} from '@principle-theorem/principle-core/interfaces';
import {
  CALENDAR_TIME_FORMAT,
  DAY_MONTH_YEAR_FORMAT,
  TIME_FORMAT,
  toMoment,
} from '@principle-theorem/shared';
import { PatientContextBuilder } from './patient-context';
import { TreatmentPlanContextBuilder } from './treatment-plan-context';

export class TreatmentStepContextBuilder
  implements IContextBuilder<ITreatmentStepTemplateContext>
{
  private _patientContextBuilder: PatientContextBuilder;

  constructor(private _data: ITreatmentStepScopeData) {
    this._patientContextBuilder = new PatientContextBuilder(this._data);
  }

  build(): ITreatmentStepTemplateContext {
    return {
      ...new TreatmentPlanContextBuilder(this._data).build(),
      treatmentStepName: this._data.treatmentStep.name,
      treatmentStepCreatedAt: toMoment(
        this._data.treatmentStep.createdAt
      ).calendar(undefined, CALENDAR_TIME_FORMAT),
      treatmentStepCreatedAtDate: toMoment(
        this._data.treatmentStep.createdAt
      ).format(DAY_MONTH_YEAR_FORMAT),
      treatmentStepCreatedAtTime: toMoment(
        this._data.treatmentStep.createdAt
      ).format(TIME_FORMAT),
      treatmentPlanName: this._data.treatmentPlan.name,
      ...this._patientContextBuilder.build(),
    };
  }
}
